module.exports = __webpack_public_path__ + "static/media/visacard.470ddc21.png";